<button
  on:click="fire('click')"
  style="
    background-color: {backgroundColor};
    color: {color};
  "
>
  <slot></slot>
</button>

<script>
export default {
  data() {
    return {
      backgroundColor: "rgb(255, 130, 0)",
      color: "white",
    }
  }
}

</script>

<style>
  button {
    /* border: solid 2px rgb(255, 130, 0); */
    outline: none;
    font-size: 13px;
    border: none;
    padding: 0 4px;
    font-weight: 500;
    height: 32px;
    line-height: 1em;
    border-radius: 4px;
    text-transform: uppercase;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    vertical-align: middle;
    -webkit-font-smoothing: antialiased;
    margin: 0;
  }
</style>